module.exports = __webpack_public_path__ + "img/lrc-space@2x.0646512f.png";